<div class="loading-overlay">
    <mat-spinner></mat-spinner>
    <div class="message">{{message}}</div>
</div>
